import { Radio, RadioGroup } from '@headlessui/react'
import { useState } from 'react'
import { FaCheckCircle } from "react-icons/fa";
import { Button } from '../../../components/ui/button';
import solLogo from '../../assets/images/solIcon.webp'
import { toast } from 'sonner';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setWhitelist } from '../../lib/userSessionSlice';
const plans = [
  { title: 'Startup', price: 250, offer: '1 week early access', disk: '1750$ normal Price ' },
  { title: 'Suporter', price: 500, offer: '3 weeks early access', disk: '5250$ normal Price ' },
  { title: 'Ambassador', price: 1000, offer: '2 months early access', disk: '15000$ normal Price' },
  { title: 'Partner', price: 5000, offer: 'exclusive access to our team group join us while working and get access to all products and news at first', disk: '' },
]

export default function WhitelistPaymentSelector({ solPrice, pay, publicKey }) {

  const [selected, setSelected] = useState(plans[0])
  // const { solPrice } = useSolPrice()

  let packagePrice = (Number(selected.price) / Number(solPrice)).toFixed(2)
  let solAmount = (Number(selected.price) / Number(solPrice)).toFixed(2)

  const dispatch = useDispatch()


  const createWhitelist = async () => {
    const confirmed = await pay(packagePrice)
    let whitelistEndpoint = process.env.REACT_APP_WHITELIST_ENDPOINT
    if (confirmed) {
      toast.success('transaction confirmed ! whitelisting your address please wait ...')
      try {
        const response = await axios.post(whitelistEndpoint, {
          walletAddress: publicKey?.toBase58(),
          transactionSignature: confirmed,
          plan: selected.title,
          payment: Number(selected.price),
          solAmount: solAmount
        }, {
          headers: {
            'Content-Type': 'application/json', // Ensure the server knows it's JSON
            'walletaddress': publicKey.toBase58(), // Custom header if needed
          }
        });
        dispatch(setWhitelist(response.data))
      } catch (error) {
        toast.error('could Not create whitelist please contact support and provide the transaction hash')
        console.error('Subscription failed:', error);
        throw error;
      }
    }
  };


  return (
    <div className="w-full space-y-5">
      <div className="mx-auto w-full ">
        <RadioGroup by="title" value={selected} onChange={setSelected} aria-label="whitelist" className="space-y-2">
          {plans.map((plan, key) => (
            <Radio
              key={plan.title}
              value={plan}
              className="group relative flex cursor-pointer rounded-lg bg-black py-4 px-5 text-white shadow-md transition focus:outline-none data-[focus]:outline-1 data-[focus]:outline-white data-[checked]:bg-neutral-500/50"
            >
              <div className="flex w-full items-center justify-between" key={key}>
                <div className="text-sm/6">
                  <p className="font-semibold text-white text-lg">{plan.title}</p>
                  <div className="grid gap-2 text-white/50 items-center">
                    <div className='flex gap-2 items-center'>

                      <p className='text-yellow-500 text-lg font-bold'>{plan.price}$</p>
                      <p className='text-green-500'>  {(plan.price / Number(solPrice)).toFixed(2)} SOL</p>
                      <img src={solLogo} alt="sol logo" className='w-3 h-3' />
                    </div>
                    <div className="flex gap-2 text-white/50 items-center">

                      <p aria-hidden="true">&middot;</p>
                      <p>{plan.offer}</p>
                      <p aria-hidden="true">&middot;</p>
                      <p className='text-xs text-center'>{plan.disk}</p>
                    </div>
                  </div>
                </div>
                <FaCheckCircle className="size-6 fill-green-500 opacity-0 transition group-data-[checked]:opacity-100" />
              </div>
            </Radio>
          ))}
        </RadioGroup>
      </div>

      {/* <Button onClick={() => pay() } disabled={false} className="w-full bg-yellow-500 hover:bg-orange-500 text-black">Whitelist Me 👏 </Button> */}
      <Button onClick={createWhitelist} disabled={false} className="w-full bg-yellow-500 hover:bg-orange-500 text-black">Whitelist Me 👏 </Button>

    </div>
  )
}